import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  TextField,
  Paper,
  Tabs,
  Tab,
  Alert,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import PendingIcon from "@mui/icons-material/Pending";
import schedule from "../../../../images/schedule.png";
import appraisal from "../../../../images/appraisal.png";
import reschedule from "../../../../images/reschedule.png";
import pending from "../../../../images/pending.png";
import scheduled from "../../../../images/scheduled.png";

import WatchLaterIcon from "@mui/icons-material/WatchLater";
import { Visibility } from "@mui/icons-material";
import {
  createInitiateAppraisal,
  getAppraisals,
  getAppraisalsMeetings,
  getLatestStatusbyId,
  setUpdataStatus,
} from "../../../../api/appraisal";
import {
  appraisalUserAction,
  handleAxiosError,
} from "../../../../config/action-config";
import {
  meetingsTable,
  appraisalTable as tableDef,
} from "../../../../config/grid-columns-defs";
import { showAlert } from "../../../../actions/alert";
import BetterControlledTable from "../../../../component/BetterControlledTable";
import ConfirmationDialog from "../appraisalComponents/confirmation.dailog";
import TabPanel from "../../../../component/TabPanel";
import { teamsLogin } from "../../../../api/auth";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Grid, Tooltip, makeStyles } from "@material-ui/core";
const emptyAppraisalData = {
  emp_id: "",
  year: "",
  appraisal_status: "",
};

const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));

export default function Appraisals() {
  const [tabIndex, setTabIndex] = useState(0);
  
  const user = useSelector((state) => state.user);
  const classes = useStyles();
  const dialogAction = useSelector((state) => state.dialog);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [appraisalId, setAppraisalId] = useState("");
  const [empAppraisalId, setEmpAppraisalId] = useState("");
  let obj = tableDef.find((o) => o.headerName === "Action");
  const [newAssetData, setNewAssetData] = useState(emptyAppraisalData);
  addAdditionalColumn(obj, dispatch, setAppraisalId);
  const [status, setStatus] = useState("");
  const [empName, setEmpName] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [latestStatus, setLatestStatus] = useState("");
  const [Empid, setEmpid] = useState([{}]);
  const [empAppStatus, setEmpAppStatus] = useState("");
  const [emp, setEmp] = useState("");
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  useEffect(() => {
    setTabIndex(0);
  }, []);

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "VIEW":
        dispatch({ type: "" });
        navigate(
          `${dialogAction.data.appraisal_id}/${dialogAction.data.role}_${dialogAction.data.department}`
        );
        break;
      case "TAB":
        setEmpAppraisalId(dialogAction.data.appraisal_id);
        setTabIndex(1);
        dispatch({ type: "" });
        console.log(
          dialogAction.data.appraisal_id,
          "dialogAction.data.appraisal_id"
        );
        break;
      case "APPRAISAL_INITIATE_DAILOG":
        dispatch({ type: "" });
        if (user.role === "Admin" && user.department === "Hr") {
          setConfirmationOpen(true);
          return;
        }
        dispatch(showAlert("Only HR can initiate the appraisal!"));
        break;
      default:
        break;
    }
  }, [dialogAction]);
  // console.log(empAppraisalId,"emp")
  const onNewInitiateAppraisalSubmit = () => {
    newAssetData.emp_id = appraisalId;
    newAssetData.appraisal_status = "Initiated";
    newAssetData.year = currentDate();
    createInitiateAppraisal(newAssetData, user.token)
      .then((res) => {
        setConfirmationOpen(false);
        dispatch(showAlert(res.data.msg));
        setNewAssetData(emptyAppraisalData);
        refreshTable();
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const [assetTableRefreshCount, setAssetTableRefreshCount] = useState(0);

  // useEffect(() => {
  //   if (!empAppraisalId) return;
  //   getStatus();
  // }, [empAppraisalId]);
  // async function getStatus() {
  //   try {
  //     const { data } = await getLatestStatusbyId(empAppraisalId, user.token);
  //     setStatus(data.data);
  //   } catch (err) {
  //     handleAxiosError(err);
  //     return { error: true };
  //   }
  // }

  async function updateStat() {
    try {
      const { data } = await setUpdataStatus(
        {
          appraisal_id: Empid.toString(),
          status: latestStatus.status,
        },
        user.token
      );
      dispatch(showAlert(data.msg));
      setOpenConfirm(false);
      refreshTable();
      setTabIndex(0);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function getAppraisalMeetingsTableData(limit, offset) {
    try {
      const { data } = await getAppraisalsMeetings(
        { limit, offset },
        user.token,
        user.msTeamsAuth
      );
      setEmpAppStatus(data.data);
      return {
        rows: data.data,
        total: data.total,
        error: data.error,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  const clearFilter = () => {
    setEmp("");
    setStatus("");
    refreshTable();
  };

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    if (name === "emp_name") setEmp(value);
    else if (name === "status") setStatus(value);
    refreshTable();
  };
  async function getAppraisalTableData(limit, offset) {
    try {
      const { data } = await getAppraisals(
        { limit, offset, status, name: emp },
        user.token
      );
      return {
        rows: data.EmployeeList,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  async function getAppraisalMeetingsTableDataRefresh(refreshMsTeamsAuth) {
    try {
      const { data } = await getAppraisalsMeetings(
        user.token,
        refreshMsTeamsAuth || user.msTeamsAuth
      );
      let mappeditem = ExtractKeysFromData(data);
      return {
        rows: mappeditem,
        total: data.data.value.length,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  function refreshTable(e) {
    e?.preventDefault();
    setAssetTableRefreshCount((prev) => prev + 1);
  }

  const onLinkAccountClick = async () => {
    try {
      const { data } = await teamsLogin(user.token);
      window.location.replace(data.link);
    } catch (error) {
      dispatch(showAlert(error));
    }
  };

  function addAdditionalColumn(obj, dispatch, setAppraisalId) {
    if (obj === undefined) {
      tableDef.unshift({
        headerName: "Action",
        field: "actions",
        resizable: true,
        wrapText: true,
        autoHeight: true,
        minWidth: 120,
        headerClass: "justify-center",
        cellClass: "justify-center",
        cellRendererFramework: (params) => {
          if (
            params?.data?.appraisal_status === null ||
            params?.data?.appraisal_status === "null" ||
            params?.data?.appraisal_status === ""
          ) {
            return (
              <Tooltip title="Appraisal">
                <Button
                  size="small"
                  variant="contained"
                  color="info"
                  onClick={() => {
                    setAppraisalId(params.data.emp_id);
                    dispatch({
                      type: "APPRAISAL_INITIATE_DAILOG",
                      data: params.data,
                    });
                  }}
                >
                  Appraisal
                </Button>
              </Tooltip>
            );
          }
          if (params?.data?.appraisal_status === "Manager_Submitted") {
            return (
              <>
                <Tooltip title="View">
                  <IconButton
                    color="info"
                    // className={buttonTheme.myClassName}
                    style={{ left: "2px" }}
                    onClick={() => {
                      if (
                        params?.data?.appraisal_status === "Manager_Submitted"
                      ) {
                        dispatch({ type: "VIEW", data: params.data });
                      }
                    }}
                  >
                    <VisibilityIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Scedule a meeting">
                  <IconButton
                    color="info"
                    style={{ left: "-10px" }}
                    // className={buttonTheme.myClassName}
                    onClick={() => {
                      dispatch({
                        type: appraisalUserAction.SET_USER_DATA,
                        payload: params?.data,
                      });
                      navigate(`/meeting-form/${params?.data?.emp_id}`);
                    }}
                  >
                    <img
                      style={{ width: "30px", height: "30px" }}
                      src={schedule}
                      alt="schedule"
                    />
                  </IconButton>
                </Tooltip>
              </>
            );
          }
          if (params?.data?.appraisal_status === "Emp_Submitted") {
            return (
              <>
                <Tooltip title="View">
                  <IconButton
                    color="info"
                    // style={{ left: "-21px" }}
                    // className={buttonTheme.myClassName}
                    onClick={() => {
                      if (params?.data?.appraisal_status === "Emp_Submitted") {
                        dispatch({ type: "VIEW", data: params.data });
                      }
                    }}
                  >
                    <VisibilityIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              </>
            );
          }
          if (params?.data?.appraisal_status === "Meeting_Reschedule") {
            return (
              <>
                <Tooltip title="View">
                  <IconButton
                    color="info"
                    onClick={() => {
                      if (
                        params?.data?.appraisal_status ===
                          "Manager_Submitted" ||
                        params?.data?.appraisal_status === "Meeting_Reschedule"
                      ) {
                        dispatch({ type: "VIEW", data: params.data });
                      }
                    }}
                  >
                    <VisibilityIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Meeting Reshedule">
                  <IconButton
                    color="inherit"
                    style={{ left: "-10px" }}
                    onClick={() => {
                      dispatch({
                        type: appraisalUserAction.SET_USER_DATA,
                        payload: params?.data,
                      });
                      navigate(`/meeting-form/${params?.data?.emp_id}`);
                    }}
                  >
                    <img
                      style={{ width: "30px", height: "30px" }}
                      src={schedule}
                      alt="schedule"
                    />
                    {/* <img style={{width:"37px",height:"40px"}} src={reschedule} alt="reschedule" /> */}
                  </IconButton>
                </Tooltip>
              </>
            );
          }
          if (params?.data?.appraisal_status === "Meeting_Pending") {
            return (
              <>
                <Tooltip title="View">
                  <IconButton
                    color="info"
                    // style={{ left: "-19px" }}
                    onClick={() => {
                      if (
                        params?.data?.appraisal_status ===
                          "Manager_Submitted" ||
                        params?.data?.appraisal_status === "Meeting_Pending"
                      ) {
                        dispatch({ type: "VIEW", data: params.data });
                      }
                    }}
                  >
                    <VisibilityIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Scedule Again">
                  <IconButton
                    color="inherit"
                    style={{ left: "-10px" }}
                    onClick={() => {
                      dispatch({
                        type: appraisalUserAction.SET_USER_DATA,
                        payload: params?.data,
                      });
                      navigate(`/meeting-form/${params?.data?.emp_id}`);
                    }}
                  >
                    <img
                      style={{ width: "30px", height: "30px" }}
                      src={schedule}
                      alt="schedule"
                    />
                    {/* <img style={{width:"30px",height:"30px"}} src={pending} alt="pending" /> */}
                  </IconButton>
                </Tooltip>
              </>
            );
          }
          // if (
          //       params?.data?.appraisal_status === "Meeting_Scheduled"
          //     ) {
          //       dispatch({ type: "TAB", data: params.data });
          //     }
          if (params?.data?.appraisal_status === "Meeting_Scheduled") {
            return (
              <Tooltip title="Meeting scheduled">
                <Box sx={{ color: "red", fontSize: "15px" }}>
                  <Button
                    size="Large"
                    sx={{ borderRadius: "10px", fontWeight: "bold" }}
                    variant="text"
                    color="success"
                    onClick={() => {
                      if (
                        params?.data?.appraisal_status === "Meeting_Scheduled"
                      ) {
                        navigate(
                          `/scheduled-meeting-form/${params?.data?.appraisal_id}`
                        );
                      }
                    }}
                  >
                    <img
                      style={{ width: "30px", height: "30px" }}
                      src={scheduled}
                      alt="scheduled"
                    />
                  </Button>
                </Box>
              </Tooltip>
            );
          }
          if (params?.data?.appraisal_status === "Appraisal_Completed") {
            return (
              <Box sx={{ color: "red", fontSize: "15px" }}>
                <Tooltip title="Completed">
                  <Button
                    size="Large"
                    sx={{ borderRadius: "10px", fontWeight: "bold" }}
                    variant="text"
                    color="success"
                    onClick={() => {
                      if (
                        params?.data?.appraisal_status === "Appraisal_Completed"
                      ) {
                        dispatch(
                          showAlert(
                            " The appraisal process has been concluded."
                          )
                        );
                      }
                    }}
                  >
                    <CheckCircleIcon />
                  </Button>
                </Tooltip>
              </Box>
            );
          }
          if (params?.data?.appraisal_status === "Initiated") {
            return (
              <Box sx={{ color: "red", fontSize: "15px" }}>
                <Tooltip title="Initiated">
                  <Button
                    size="Large"
                    sx={{ borderRadius: "10px", fontWeight: "bold" }}
                    variant="text"
                    color="info"
                    onClick={() => {
                      if (params?.data?.appraisal_status === "Initiated") {
                        dispatch(
                          showAlert(
                            " The appraisal process has been Initiated."
                          )
                        );
                      }
                    }}
                  >
                    <img
                      style={{ width: "37px", height: "40px" }}
                      src={appraisal}
                      alt="appraisal"
                    />
                  </Button>
                </Tooltip>
              </Box>
            );
          } else {
            return null;
          }
        },
      });
    }
  }

  const onFormChange = (event) => {
    const { name, value } = event.target;
    setLatestStatus({ ...latestStatus, [name]: value });
  };

  // if (!user.msTeamsAuth)
  //   return (
  //     <Paper elevation={3}>
  //       <Box p={1} textAlign="center">
  //         <Alert severity="info">
  //           You need to link your Microsoft Teams Account to View Teams Meeting.
  //         </Alert>

  //         <Button
  //           sx={{ mt: 1 }}
  //           variant="contained"
  //           onClick={onLinkAccountClick}
  //           color="secondary"
  //         >
  //           Link Account
  //         </Button>
  //       </Box>
  //     </Paper>
  //   );
  return (
    <Box className="pmt-container-box">
      <Box className="appraisal-title-box ">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Appraisal
          </Typography>
        </Box>
      </Box>
      <br />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          boxShadow: "0 4px 6px -1px #d0d0d0",
          borderRadius: "6px",
          padding: { sm: "15px 20px", xs: "8px 8px" },
          background: "#178af4",
          color: "#101728",
          width: "100%",
          height:"70px"
        }}
      >
            {tabIndex===0 &&
        <Grid
          container
          className="report-filter-box"
          columnspacing={{ xs: 1, sm: 1, md: 1 }}
          item
          spacing={3}
        >
       
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <TextField
              name="emp_name"
              size="small"
              fullWidth
              value={emp}
              onChange={handleFilterChange}
              label="Employee Name"
              type="text"
              // variant="outlined"
            />
          </Grid>
         
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <TextField
              name="status"
              size="small"
              fullWidth
              value={status}
              onChange={handleFilterChange}
              label="Appraisal Status"
              type="text"
              // variant="outlined"
            />
          </Grid>

          <Grid item lg={2} md={2} sm={4} xs={6}>
            <Button
              onClick={() => clearFilter()}
              size="medium"
              variant="contained"
              color="error"
              sx={{ fontWeight: "bold", borderRadius: "15px" }}
            >
              Reset
            </Button>
          </Grid>


          <Grid
            sx={{ display: "flex", justifyContent: "end", gap: 2 }}
            item
            lg={4}
            md={4}
            sm={2}
            xs={2}
          ></Grid>
        </Grid>
}
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Appraisals"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          {/* <Tab
            label="Audit"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          /> */}
          <Tab
            label="Appraisal's Meetings"
            id="simple-tab-2"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
        <TabPanel value={tabIndex} index={0}>
          <Paper>
            <div className="pmt-controll-table">
              <BetterControlledTable
                hasActionButtons={false}
                getTableRows={getAppraisalTableData}
                columns={tableDef}
                perPage={10}
                refreshCounter={assetTableRefreshCount}
                onCellClicked={(params) => {
                  setAppraisalId(params?.data?.emp_id);
                }}
              />
            </div>
          </Paper>
        </TabPanel>
        {/* <TabPanel value={tabIndex} index={1}>
        <Paper>
          <AuditList></AuditList>
        </Paper>
      </TabPanel> */}
        <TabPanel value={tabIndex} index={1}>
          <Paper>
            <div className="pmt-controll-table" style={{ overflowX: "scroll" }}>
              <BetterControlledTable
                hasActionButtons={false}
                getTableRows={getAppraisalMeetingsTableData}
                columns={[
                  ...meetingsTable,
                  {
                    headerName: "Meeting URL",
                    field: "meeting_url",
                    resizable: true,
                    // autoHeight: true,
                    cellClass: "pmt-ag-cell-font capitalizeNone",
                    maxWidth: 250,
                    minWidth: 130,
                    cellRenderer: (params) => (
                      <Button
                        size="small"
                        sx={{ borderRadius: "10px" }}
                        variant="contained"
                        color="primary"
                      >
                        <a href={params.value} target="_blank">
                          {"Meeting Url"}
                        </a>
                      </Button>
                    ),
                  },
                  {
                    headerName: "Status",
                    field: "appraisal_status",
                    resizable: true,
                    // autoHeight: true,
                    cellClass: "pmt-ag-cell-font capitalizeNone",
                    maxWidth: 300,
                    minWidth: 170,
                    cellRenderer: (params) =>
                      params?.data?.appraisal_status !==
                      "Appraisal_Completed" ? (
                        <Button
                          size="small"
                          sx={{ borderRadius: "10px" }}
                          variant="contained"
                          color="info"
                          onClick={() => {
                            setEmpid(params?.data?.appraisal_id);
                            setOpenConfirm(true);
                          }}
                        >
                          Update Status
                        </Button>
                      ) : (
                        <Button
                          size="small"
                          sx={{ borderRadius: "10px" }}
                          variant="contained"
                          color="success"
                        >
                          Completed
                        </Button>
                      ),
                  },
                ]}
                perPage={10}
                refreshCounter={assetTableRefreshCount}
                onCellClicked={(params) => {
                  setAppraisalId(params?.data?.emp_id);
                }}
              />
            </div>
          </Paper>
        </TabPanel>
      </Box>

      <Dialog
        open={openConfirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <>
          <DialogTitle id="alert-dialog-title">Confirm Update</DialogTitle>
          <DialogContent style={{ width: "500px", paddingTop: "10px" }}>
            <FormControl fullWidth>
              <InputLabel id="status-label">
                please select the Status
              </InputLabel>
              <Select
                name="status"
                label="Update Status"
                value={latestStatus.status}
                style={{ cursor: "pointer" }}
                sx={{ background: "#fff", borderRadius: "4px" }}
                onChange={onFormChange}
              >
                <MenuItem value="Appraisal_Completed">
                  Appraisal Completed
                </MenuItem>
                <MenuItem value="Meeting_Reschedule">ReSchedule</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              size="medium"
              sx={{ marginBottom: "10px" }}
              onClick={() => {
                setOpenConfirm(false);
              }}
              variant="contained"
              color="inherit"
            >
              Cancel
            </Button>
            <Button
              size="medium"
              sx={{ marginBottom: "10px" }}
              onClick={() => {
                updateStat();
              }}
              variant="contained"
              color="info"
            >
              Confirm
            </Button>
          </DialogActions>
        </>
      </Dialog>
      <Dialog
        open={confirmationOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <>
          <DialogTitle id="alert-dialog-title">Confirm Appraisal</DialogTitle>
          <DialogContent style={{ width: "500px" }}>
            <DialogContentText id="alert-dialog-description">
              <p>Are you sure you want to Initiate Appraisal?</p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size="medium"
              onClick={() => {
                setConfirmationOpen(false);
              }}
              variant="contained"
              color="inherit"
            >
              Cancel
            </Button>
            <Button
              size="medium"
              onClick={() => {
                onNewInitiateAppraisalSubmit();
              }}
              variant="contained"
              color="info"
            >
              Confirm
            </Button>
          </DialogActions>
        </>
      </Dialog>
    </Box>
  );
}

function currentDate() {
  const date = new Date();
  if (!date || isNaN(date.getTime())) {
    return "N/A";
  }
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
}

function ExtractKeysFromData(data) {
  return data.data.value.map((e) => ({
    title: e.subject,
    link: e.onlineMeeting["joinUrl"],
    start: e.start["dateTime"],
    end: e.end["dateTime"],
    attendees: e.attendees
      .map((element) => element.emailAddress["name"])
      .join(", "),
    organizer: e.organizer.emailAddress["name"],
  }));
}
export function createDateAsUTC(date) {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    )
  );
}